(() => {
  'use strict';
  if (window.LymiaAppearance) return;

  const selector = '[data-lymia-appearance]';
  const normalize = (value) => value === 'arcade' ? 'arcade' : 'fuji';
  let look = null;

  const apply = (value) => {
    const next = normalize(value);
    document.documentElement.setAttribute('data-lymia-look', next);
    if (next === look) return look;
    look = next;
    document.dispatchEvent(new CustomEvent('lymia:appearance', { detail: { look } }));
    return look;
  };
  const markerWithin = (element) => {
    if (element?.matches?.(selector)) return element;
    return element?.querySelector?.(selector) || null;
  };
  const read = (marker) => apply(marker?.getAttribute('data-look'));

  // Shopify re-renders section markup without re-running its inline scripts.
  // Read only the section involved, so unrelated editor updates leave the look alone.
  document.addEventListener('shopify:section:load', (event) => {
    const marker = markerWithin(event.target);
    if (marker) read(marker);
  });
  document.addEventListener('shopify:section:unload', (event) => {
    if (!markerWithin(event.target)) return;
    // The unload event can arrive before the old section leaves the DOM.
    const replacement = Array.from(document.querySelectorAll(selector))
      .find((marker) => marker !== event.target && !event.target.contains(marker));
    read(replacement);
  });

  // The API is a temporary preview override. Shopify remains the saved source.
  window.LymiaAppearance = Object.freeze({ set: apply, get: () => look });
  read(document.querySelector(selector));
})();
